import { render, staticRenderFns } from "./resultStepsSummary.vue?vue&type=template&id=38c9b0e6&scoped=true&"
import script from "./resultStepsSummary.vue?vue&type=script&lang=js&"
export * from "./resultStepsSummary.vue?vue&type=script&lang=js&"
import style0 from "./resultStepsSummary.vue?vue&type=style&index=0&id=38c9b0e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c9b0e6",
  null
  
)

export default component.exports